import '../styles/AthleteTabs.css';
import '../styles/AthletePage.css';

import React from 'react';

interface AthleteTabsLoadingProps {
  count?: number;
}

export default function AthleteTabsLoading({ count = 5 }: AthleteTabsLoadingProps) {
  // Create an array of the specified count for rendering multiple shimmer items
  const shimmerItems = Array.from({ length: count }, (_, index) => index);
  
  return (
    <div className="athlete-tabs">
      {/* Home button */}
      <div className="tab-button shimmer" style={{ 
        minWidth: '50px', 
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        backgroundColor: '#f5f5f5',
        color: 'white',
        borderRadius: '8px'
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
        </svg>
      </div>
      
      {/* Athlete tab shimmers */}
      {shimmerItems.map(index => (
        <div 
          key={index} 
          className="tab-button shimmer" 
          style={{ 
            minWidth: '80px',
            height: '48px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 16px',
            flexShrink: 0,
            borderRadius: '8px',
            backgroundColor: '#f5f5f5'
          }}
        ></div>
      ))}
    </div>
  );
} 